<template>
  <div>
    <h1 class="title">Gestione scheda</h1>
    <h2 class="subtitle" v-if="pageReady">
      {{ $ajax.getObject("servicesTipology")[1].name }}
    </h2>

    <form v-on:submit="formSubmit" :disabled="currentCard.locked">
      <div class="content has-text-left">
        <div v-if="!currentCard.id">
          Stai creando una nuova scheda, inserisci i dati relativi all'esercizio
          e premi
          <button
            class="button is-success is-small"
            :disabled="$ajax.anyLoading"
          >
            <span>Salva scheda</span>
          </button>
          <br />
          <small>
            Dopo la creazione, questi campi non potranno essere modificati.
          </small>
        </div>
      </div>

      <div class="content" v-if="currentCard.locked">
        <b-icon icon="lock" size="is-large" type="is-info"></b-icon>
        <div>
          La scheda è bloccata. Se hai necessità di effettuare modifiche
          contatta l'amministrazione.
        </div>
      </div>

      <section class="content">
        <div class="columns">
          <div class="column">
            <b-field label="Data di esercizio">
              <!-- :min-date="minDate" -->
              <b-datepicker
                v-if="!currentCard.id || !currentCard.locked"
                placeholder="Seleziona data..."
                v-model="currentCard.exposedAt"
                :max-date="maxDate"
                required
              ></b-datepicker>
              <div v-else>{{ currentCard.exposedAt | date }}</div>
            </b-field>

            <div v-if="currentCard.id && currentCard.exposedAt">
              <h3 class="subtitle is-6">Sessione #1</h3>
              <div class="columns is-vcentered is-mobile">
                <div class="column">
                  <b-field label="Inizio">
                    <b-timepicker
                      locale="it-IT"
                      v-model="currentCard.timeStart"
                      :incrementMinutes="15"
                      placeholder="Orario inizio"
                      inline
                      class="has-text-centered"
                      default-minutes="0"
                    ></b-timepicker
                  ></b-field>
                </div>
                <div class="column">
                  <b-field label="Fine">
                    <b-timepicker
                      locale="it-IT"
                      v-model="currentCard.timeEnd"
                      :incrementMinutes="15"
                      placeholder="Orario inizio"
                      inline
                      class="has-text-centered"
                      default-minutes="0"
                    ></b-timepicker
                  ></b-field>
                </div>

                <div class="column">
                  <!--
                  <b-button v-on:click="resetSession2" class="has-text-primary"
                    >Reset</b-button
                  >-->
                </div>
              </div>
              <h3 class="subtitle is-6">Sessione #2</h3>

              <div class="columns is-vcentered is-mobile">
                <div class="column">
                  <b-field label="Inizio">
                    <b-timepicker
                      locale="it-IT"
                      v-model="currentCard.timeStart2"
                      :incrementMinutes="15"
                      placeholder="Orario inizio"
                      inline
                      class="has-text-centered"
                      default-minutes="0"
                    ></b-timepicker
                  ></b-field>
                </div>
                <div class="column">
                  <b-field label="Fine">
                    <b-timepicker
                      locale="it-IT"
                      v-model="currentCard.timeEnd2"
                      :incrementMinutes="15"
                      placeholder="Orario inizio"
                      inline
                      class="has-text-centered"
                      default-minutes="0"
                    ></b-timepicker
                  ></b-field>
                </div>
                <div class="column">
                  <b-button v-on:click="resetSession2" class="has-text-primary"
                    >Reset</b-button
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="column">
            <!-- SEARCH CUSTOMERS -->
            <SearchGeneric
              v-if="!currentCard.id"
              preload="true"
              label="Cerca cliente"
              apiaddress="/users/search/"
              :terms="{
                customersonly: true,
                tipologyId: this.currentCard.tipologyId,
              }"
              v-on:eventSelected="handleCustomerSelected"
              required
            ></SearchGeneric>
            <div v-else>
              <label class="label">Cliente</label>
              <span v-if="currentCard.customer">
                {{ currentCard.customer.name }}
              </span>
            </div>
          </div>
          <div class="column">
            <!-- SEARCH SALES POINTS -->
            <SearchGeneric
              v-if="!currentCard.id"
              preload="true"
              apiaddress="/salespoints/search"
              :label="label_location_salespoint"
              :terms="{ tipologyId: currentCard.tipologyId }"
              :nameFormat="nameFormatSalesPoint"
              :searchOnFields="salesPointSearchFields"
              v-on:eventSelected="handleSalesPointSelected"
              required
            ></SearchGeneric>
            <div v-else>
              <label class="label">Sales Point</label>
              <span v-if="currentCard.salePoint">
                {{ currentCard.salePoint.name }}
              </span>
            </div>
          </div>
        </div>
        <!--<pre>{{ haveSecondSessionTime }}</pre>
        <pre class="has-text-left is-small">{{ currentCard }}</pre>
        -->
        <!-- Inserisci prodotto -->
        <div class="columns" v-if="currentCard.id && !currentCard.locked">
          <div class="column has-text-left">
            <SearchGeneric
              v-if="currentCard.customer.id"
              preload="true"
              label="Ricerca prodotto"
              apiaddress="/products/search"
              v-on:eventSelected="handleProductSelected"
              :terms="{ customerId: currentCard.customer.id, limit: 25 }"
              :disabled="!pageReady"
              :nameFormat="nameFormatFunc"
              clearOnSelect
            ></SearchGeneric>
          </div>
          <div class="column"></div>
        </div>
      </section>

      <section class="content">
        <b-table
          :data="currentCard.products"
          :loading="$ajax.anyLoading"
          narrowed
          striped
          class="has-text-left"
        >
          <b-table-column field="name" label="Prodotto" v-slot="props" sortable>
            {{ props.row.name }}
          </b-table-column>

          <!-- TABELLA PROMOTER(1) prezzo di vendita prodotti in negozio -->
          <b-table-column
            v-if="currentCard.tipologyId == 1"
            field="sellingPrice"
            label="Prezzo €"
            width="100"
            numeric
            sortable
            v-slot="props"
          >
            <b-field v-if="!currentCard.locked">
              <currency-input
                v-if="!currentCard.locked"
                v-model="props.row.sellingPrice"
              />
            </b-field>
            <span v-else>{{ props.row.sellingPrice }}</span>
          </b-table-column>
          <!-- FINE PREZZO DI VENDITA -->

          <!-- COLONNA STOCK -->
          <b-table-column
            field="stock"
            label="Stock"
            width="120"
            numeric
            sortable
            v-slot="props"
          >
            <b-field
              v-if="!currentCard.locked"
              :type="checkStockOutage(props.row, 'type')"
              :message="checkStockOutage(props.row, 'message')"
            >
              <b-input
                type="number"
                size="is-small"
                v-model="props.row.stock"
                min="1"
                required
                placeholder="Stock"
              ></b-input>
            </b-field>
            <span v-else>{{ props.row.stock }}</span>
          </b-table-column>

          <b-table-column
            field="piecesSold"
            label="Venduti"
            width="120"
            numeric
            sortable
            v-slot="props"
          >
            <b-field v-if="!currentCard.locked">
              <b-input
                size="is-small"
                placeholder="Venduti"
                type="number"
                v-model="props.row.piecesSold"
                :min="Math.min(props.row.stock, 0)"
                :max="props.row.stock"
              ></b-input>
            </b-field>
            <span v-else>{{ props.row.piecesSold }}</span>
          </b-table-column>

          <!--
            <b-table-column width="120" label="Qty" numeric>
              <span v-if="props.row.pieces > 1">{{ props.row.pieces }}*</span>
              <span>{{ props.row.quantity }}</span>
              {{ $ajax.getObject("productsUm")[props.row.umId].name }}
            </b-table-column>
-->
          <!--
              :visible="props.row.pieces > 1"
            
            <b-table-column width="70" label="Unità" numeric>
              
            </b-table-column>
            -->
          <!--
            <b-table-column width="60" label="Totale" numeric>
              {{ props.row.pieces * props.row.piecesSold * props.row.quantity }}
            </b-table-column>
            -->
          <b-table-column
            width="60"
            :visible="!currentCard.locked"
            class="has-text-right"
            v-slot="props"
          >
            <button
              class="button is-small is-danger"
              @click.prevent="onDeleteProduct(props.row)"
            >
              <b-icon icon="trash" size="is-small"></b-icon>
            </button>
          </b-table-column>

          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="cookie-bite" size="is-large"></b-icon>
                </p>
                <p v-if="!currentCard.id">
                  Imposta la data, il cliente, la location e salva la scheda.
                </p>
                <p v-else>Lista prodotti vuota</p>
              </div>
            </section>
          </template>
        </b-table>
      </section>

      <section class="content" v-if="!currentCard.locked">
        <div class="buttons is-right">
          <button class="button is-success" :disabled="$ajax.anyLoading">
            <b-icon icon="check" size="is-small"></b-icon>
            <span>Salva scheda</span>
          </button>
        </div>
      </section>

      <!-- SCHEDA VALUTATIVA -->
      <div class="container" v-if="currentCard.id && pageReady">
        <div class="notification">
          <h1 class="subtitle">Scheda valutativa</h1>
        </div>

        <ValutationPromoter
          :currentCard="currentCard"
          v-if="currentCard.tipologyId == 1"
        ></ValutationPromoter>
        <ValutationBrandAmbassador
          :currentCard="currentCard"
          v-if="currentCard.tipologyId == 2"
        ></ValutationBrandAmbassador>

        <div class="buttons is-right" v-if="!currentCard.locked">
          <a
            class="button is-danger"
            :disabled="$ajax.anyLoading"
            v-if="currentCard.id && $ajax.getUserRole().cardDelete"
            v-on:click="onDelete"
          >
            <span class="icon is-small">
              <i class="fas fa-trash"></i>
            </span>
            <span>Elimina scheda</span>
          </a>
          <button class="button is-success" :disabled="$ajax.anyLoading">
            <b-icon icon="check" size="is-small"></b-icon>
            <span>Salva scheda</span>
          </button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import SearchGeneric from "@/components/SearchGeneric";
import moment from "moment";
import router from "@/router.js";
import Vue from "vue";

import ValutationPromoter from "@/components/CardValulationFields/ValutationPromoter";
import ValutationBrandAmbassador from "@/components/CardValulationFields/ValutationBrandAmbassador";

var cardDefault = () => ({
  id: 0,
  timeStart: nowNoTime(),
  timeEnd: nowNoTime(),
  timeStart2: nowNoTime(),
  timeEnd2: nowNoTime(),
  customer: {},
  salePoint: {},
  products: [],
  valutations: { placement: "" },
  tastings: 0,
  contacts: 0,
  stock: 0,
  competitors: [],
});

var nowNoTime = () =>
  new Date(
    new Date().getFullYear(),
    new Date().getMonth(),
    new Date().getDate()
  );

export default {
  components: {
    SearchGeneric,
    ValutationPromoter,
    ValutationBrandAmbassador,
  },
  data() {
    return {
      pageReady: false,
      salesPointSearchFields: ["name", "ensign"],
      currentCard: cardDefault(),
      date: new Date(),
      minDate: new Date(),
      maxDate: new Date(),
      nameFormatFunc: (data) => {
        var emoji = "";

        switch (data.tipologyId) {
          case 1:
            emoji = "🥫";
            break;
          case 2:
            emoji = "📦";
            break;
          default:
            break;
        }

        if (data.isGadget) emoji = "🎁";

        return `${emoji} ${data.name} (${data.pieces}x${data.quantity}=${data.total})`;
      },
      nameFormatSalesPoint: (data) => {
        return `${data.name} [${data.ensign}]`;
      },
    };
  },
  methods: {
    resetSession2() {
      this.currentCard.timeStart2 = null;
      this.currentCard.timeEnd2 = null;
    },
    fixDate(dt) {
      if (dt == null) return;
      return moment(dt).utc(true).toDate();
    },

    onDelete() {
      const vm = this;
      this.$buefy.dialog.confirm({
        title: "Cancella scheda",
        message: `Sei sicuro di voler <b>eliminare</b> questa scheda? Verrà rimossa da tutte le statistiche. <b>Questa azione è irreversibile</b>.`,
        confirmText: "Elimina",
        cancelText: "Annulla",
        type: "is-danger",
        scroll: "keep",
        hasIcon: true,
        onConfirm: () => {
          this.$ajax.request({
            address: "/cards/promoter/" + this.currentCard.id,
            method: "DELETE",
            onSuccess: (response) => {
              //vm.currentCard = response.data;
              vm.currentCard.id = 0;
              router.push({ name: "cards" });
            },
          });
        },
      });
    },
    onDeleteProduct(row) {
      this.$buefy.dialog.confirm({
        title: "Rimozione prodotto",
        message: `Vuoi <b>rimuovere</b> il prodotto <i>${row.name}</i> dalla lista?`,
        confirmText: "Rimuovi",
        cancelText: "Annulla",
        type: "is-warning",
        scroll: "keep",
        hasIcon: true,
        onConfirm: () => {
          // no ajax actions
          let index = this.currentCard.products.indexOf(row);
          if (index !== -1) {
            this.currentCard.products.splice(index, 1);
          }
        },
      });
    },
    softByPieces(a, b, o) {
      if (o) return a.piecesSold > b.piecesSold;
      return a.piecesSold < b.piecesSold;
    },
    formSubmit(e) {
      e.preventDefault();

      // fix timezone offset (1day off)
      let card = JSON.parse(JSON.stringify(this.currentCard));
      card.exposedAt = this.fixDate(card.exposedAt);

      if (card.id) {
        // SE PROMOTER(1) e timeEnd non settato
        if (card.timeStart >= card.timeEnd) {
          this.$buefy.dialog.alert({
            title: "Sessione #1",
            message: `L'orario di <b>fine esercizio</b> deve essere maggiore dell'<b>orario di inizio</b>. Il valore può essere cambiato.`,
            confirmText: "Ok",
            type: "is-warning",
            scroll: "keep",
            hasIcon: true,
          });
          return;
        }

        if (this.haveSecondSessionTime) {
          if (card.timeStart2 < card.timeEnd) {
            this.$buefy.dialog.alert({
              title: "Sessione #2",
              message: `L'orario di <b>inizio esercizio</b> della sessione #2 deve essere maggiore dell'<b>orario di fine</b> della prima sessione`,
              confirmText: "Ok",
              type: "is-warning",
              scroll: "keep",
              hasIcon: true,
            });
            return;
          }

          if (card.timeEnd2 < card.timeStart2) {
            this.$buefy.dialog.alert({
              title: "Sessione #2",
              message: `L'orario di fine sessione #2 deve essere maggiore dell'orario di inizio`,
              confirmText: "Ok",
              type: "is-warning",
              scroll: "keep",
              hasIcon: true,
            });
            return;
          }
        } // if haveSecondSessionTime
      } // if card.id

      if (this.currentCard.id) {
        this.updateCard(card);
      } else {
        this.saveCard(card);
      }
    },
    saveCard(card) {
      // creo una nuova scheda
      const vm = this;
      this.$ajax.request({
        address: "/cards/promoter/",
        method: "POST",
        data: this.currentCard,
        onSuccess: (response) => {
          response.data.exposedAt = new Date(response.data.exposedAt);
          vm.currentCard = response.data;

          router.push({ name: "card", params: { id: response.data.id } });
        },
      });
    },
    updateCard(card) {
      const vm = this;

      this.$ajax.request({
        address: "/cards/promoter/" + card.id,
        method: "PUT",
        data: card,
        onSuccess: (response) => {
          response.data.exposedAt = new Date(response.data.exposedAt);
          response.data.timeStart = new Date(response.data.timeStart);
          response.data.timeEnd = new Date(response.data.timeEnd);

          if (response.data.timeStart2)
            response.data.timeStart2 = new Date(response.data.timeStart2);
          if (response.data.timeEnd2)
            response.data.timeEnd2 = new Date(response.data.timeEnd2);

          vm.currentCard = response.data;
        },
      });
    },
    handleCustomerSelected(selected) {
      this.currentCard.customer = selected;
      this.currentCard.customerId = selected.id;
    },
    handleSalesPointSelected(selected) {
      this.currentCard.salePoint = selected;
      this.currentCard.salePointId = selected.id;
    },
    handleProductSelected(selected) {
      if (this.currentCard.products.some((e) => e.id === selected.id)) {
        this.$buefy.dialog.alert({
          title: "Duplicato",
          message: `Il prodotto che hai selezionato è già presente nell'elenco`,
          confirmText: "Ok",
          type: "is-warning",
          scroll: "keep",
          hasIcon: true,
        });
      } else {
        //selected.piecesSold = 1; // piecesSold non ricevuto dall'api /products/ in quanto relativo a cardProducts
        Vue.set(selected, "piecesSold", 0);
        Vue.set(selected, "stock", 1);

        this.currentCard.products.push(selected);
      }
    },
    getPreviousMonday() {
      var prevMonday = new Date();
      prevMonday.setDate(
        prevMonday.getDate() - ((prevMonday.getDay() + 6) % 7)
      );
      return prevMonday.getDate();
    },
    getNextSunday() {
      return this.getPreviousMonday() + 6;
    },
    checkStockOutage(row, type) {
      var stock = parseInt(row.stock);
      var piecesSold = parseInt(row.piecesSold);

      var isStockOutage = stock <= piecesSold;
      //var isMissingProduct = stock == 0;

      if (!isStockOutage) return;
      else if (isStockOutage) {
        switch (type) {
          case "type":
            return "is-info";
          case "message":
            return "Rottura stock";
        }
      }

      return "checkStockOutage type sconociuto";
    },
  },
  created() {
    this.currentCard.tipologyId = this.currentTipology.id;
    //const today = new Date();
    //this.minDate.setDate(today.getDate() - this.userRole.cardCreatePastLimit);
  },
  mounted() {
    if (this.$route.params.id) {
      this.currentCard.id = this.$route.params.id;

      const vm = this;
      this.$ajax.request({
        address: "/cards/promoter/" + this.$route.params.id,
        method: "GET",
        onSuccess: (response) => {
          response.data.exposedAt = new Date(response.data.exposedAt);
          response.data.timeStart = new Date(response.data.timeStart);
          response.data.timeEnd = new Date(response.data.timeEnd);

          if (response.data.timeStart2)
            response.data.timeStart2 = new Date(response.data.timeStart2);
          if (response.data.timeEnd2)
            response.data.timeEnd2 = new Date(response.data.timeEnd2);

          vm.currentCard = response.data;
          vm.pageReady = true;
        },
      });
    } else {
      this.pageReady = true;
    }
  },
  computed: {
    isNewCard() {
      return !this.currentCard.id;
    },
    canEditHeader() {
      return !this.currentCard.id && this.currentCard.locked;
    },
    userRole() {
      return this.$ajax.getObject("roles")[this.$ajax.getUser().roleId];
    },
    userTipologyId() {
      return this.userRole.tipologyId;
    },
    currentTipology() {
      if (this.currentCard.tipologyId) {
        return this.$ajax.getObject("servicesTipology")[
          this.currentCard.tipologyId
        ];
      } else if (this.userTipologyId) {
        return this.$ajax.getObject("servicesTipology")[this.userTipologyId];
      } else {
        // TODO: se non c'è nessun id ? fallo selezionare all'user/admin !
        return this.$ajax.getObject("servicesTipology")[1];
      }

      //return { id: 0, name: "???" };
    },
    label_location_salespoint() {
      switch (this.currentCard.tipologyId) {
        case 1:
          return "Sales Point";
        case 2:
          return "Location";
        default:
          return "?";
      }
    },
    haveSecondSessionTime() {
      if (
        this.currentCard.exposedAt &&
        this.currentCard.timeStart2 != null &&
        this.currentCard.timeEnd2 != null
      ) {
        // TODO: imposta orario al giorno corrente

        this.currentCard.timeStart2 = new Date(
          this.currentCard.exposedAt.getFullYear(),
          this.currentCard.exposedAt.getMonth(),
          this.currentCard.exposedAt.getDate(),
          this.currentCard.timeStart2.getHours(),
          this.currentCard.timeStart2.getMinutes(),
          0
        );

        this.currentCard.timeEnd2 = new Date(
          this.currentCard.exposedAt.getFullYear(),
          this.currentCard.exposedAt.getMonth(),
          this.currentCard.exposedAt.getDate(),
          this.currentCard.timeEnd2.getHours(),
          this.currentCard.timeEnd2.getMinutes(),
          0
        );

        return true;
      }

      return false;
    },
  },
};
</script>
